import styles from "../detalheEsocial.styles.module.css";
import ReguaAnos from "./ReguaAnos";
import { GRUPOS_RUBRICAS } from "../utils/gruposColunasRubricas.util";

export function gruposExibidos(gruposAtivos) {
  return GRUPOS_RUBRICAS.filter(
    (g) => g.id === "inss" || (gruposAtivos || []).includes(g.id)
  );
}

const COLUNAS_FIXAS_ANTES = [
  "Código da Rubrica",
  "Descrição da Rubrica",
  "Período de vigência",
  "Tipo da Rubrica",
];

// Colunas editáveis que ficam à direita dos grupos de incidência.
const COLUNAS_FIXAS_DEPOIS = ["Incidência da Rubrica", "Base Legal", "Verbas de Afastamento"];

/**
 * TXM-671 — cabeçalho em dois níveis da tabela de Rúbricas: linha 1 com as colunas fixas
 * (rowSpan 2) e um cabeçalho por grupo de incidência exibido (colSpan = nº de colunas);
 * linha 2 com as colunas de cada grupo. A cor vem do grupo.
 *
 * @param {{ gruposAtivos: string[], escala?: {inicio: string, fim: string}|null }} props
 */
export default function CabecalhoRubricas({ gruposAtivos, escala }) {
  const grupos = gruposExibidos(gruposAtivos);
  return (
    <thead>
      <tr>
        {COLUNAS_FIXAS_ANTES.map((titulo) => (
          <th key={titulo} rowSpan={2} title={titulo}>
            {titulo}
            {titulo === "Período de vigência" ? <ReguaAnos escala={escala} /> : null}
          </th>
        ))}
        {grupos.map((grupo) => (
          <th
            key={grupo.id}
            colSpan={grupo.colunas.length}
            className={`${styles.thGrupo} ${styles[`thGrupo_${grupo.id}`]}`}
          >
            {grupo.rotulo}
          </th>
        ))}
        {COLUNAS_FIXAS_DEPOIS.map((titulo) => (
          <th key={titulo} rowSpan={2} title={titulo}>
            {titulo}
          </th>
        ))}
      </tr>
      <tr>
        {grupos.flatMap((grupo) =>
          grupo.colunas.map((coluna, i) => (
            <th
              key={coluna.chave}
              title={`${grupo.rotulo} — ${coluna.rotulo}`}
              className={`${styles.thSubGrupo} ${styles[`thSubGrupo_${grupo.id}`]}${
                i === 0 ? ` ${styles.thSubGrupoPrimeira}` : ""
              }`}
            >
              {coluna.rotulo}
            </th>
          ))
        )}
      </tr>
    </thead>
  );
}
